import { Component, ElementRef, OnInit } from "@angular/core";
import { SVG } from "@svgdotjs/svg.js";

@Component({
  selector: "app-almacen-estantes",
  templateUrl: "./almacen-estantes.component.html",
  styleUrls: ["./almacen-estantes.component.css"],
})
export class AlmacenEstantesComponent implements OnInit {
  private draw: any; // Variable para SVG.js

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.dibujarAlmacen();
  }

  // Función para dibujar la estructura del almacén
  dibujarAlmacen(): void {
    // Inicializamos el lienzo de SVG.js
    this.draw = SVG().addTo(this.el.nativeElement).size(800, 600); // Tamaño del almacén

    const gridSpacing = 20; // Distancia entre líneas de la cuadrícula
    const offset = 20;
    const almacenWidth = 760;
    const almacenHeight = 500;
    const estanteWidth = 70; // Ancho de cada estante
    const estanteHeight = 100; // Altura de cada estante

    this.draw
      .rect(almacenWidth, almacenHeight)
      .fill("#e0e0e0")
      .stroke({ width: 1, color: "#000" })
      .move(offset, offset);

    let count = 1;
    // Dibujar las líneas verticales (punteadas)
    for (let x = gridSpacing; x < almacenWidth + offset; x += gridSpacing) {
      const text = this.draw.text(`${count}`);
      text.move(x, 0).font({ fill: "#f06" });

      this.draw
        .line(x + offset, offset, x + offset, almacenHeight + offset)
        .stroke({ color: "#000", width: 1, dasharray: "4,4" }); // Línea punteada
      count++;
    }

    count = 0;
    // Dibujar las líneas horizontales (punteadas)
    for (let y = gridSpacing; y < almacenHeight + offset; y += gridSpacing) {
      const text = this.draw.text(String.fromCharCode(65 + count));
      text.move(0, y).font({ fill: "#f06" });

      this.draw
        .line(offset, y + offset, almacenWidth + offset, y + offset)
        .stroke({ color: "#000", width: 1, dasharray: "4,4" }); // Línea punteada
      count++;
    }

    // Dibujamos el fondo del almacén
    // this.draw
    //   .rect(almacenWidth, almacenHeight)
    //   .fill("#e0e0e0")
    //   .stroke({ width: 1, color: "#000" });

    // Dibujamos los estantes A-J (10 estantes)
    const estantes = [];
    for (let i = 0; i < 5; i++) {
      const x = 50 + i * (estanteWidth + 20); // Espaciado entre estantes
      const y = 50;
      const estante = this.draw.group().addClass("estante");
      estantes.push(estante);

      const text = this.draw.text(String.fromCharCode(65 + i));
      text.move(x + 3, y).font({ fill: "#f06" });

      // Dibujamos los niveles dentro del estante
      for (let j = 0; j < 5; j++) {
        const nivelY = y + j * (estanteHeight / 5); // Espaciado de los niveles

        estante
          .rect(estanteWidth, estanteHeight / 5)
          .fill("#f4f4f4")
          .stroke({ width: 1, color: "#000" })
          .move(x, nivelY);
      }
    }

    // Agregar productos aleatorios en algunos niveles
    // this.agregarProductosAleatorios(estantes, almacenWidth, almacenHeight);
  }

  // Función para agregar productos aleatorios
  agregarProductosAleatorios(
    estantes: any[],
    _almacenWidth: number,
    _almacenHeight: number
  ): void {
    const productos = [
      "Producto 1",
      "Producto 2",
      "Producto 3",
      "Producto 4",
      "Producto 5",
    ];

    // Para cada estante, agregamos productos aleatorios
    estantes.forEach((estante, index) => {
      const numProductos = Math.floor(Math.random() * 3); // Número aleatorio de productos en este estante (0-2)
      const estanteWidth = 70;
      const estanteHeight = 100;

      for (let i = 0; i < numProductos; i++) {
        const nivel = Math.floor(Math.random() * 5); // Nivel aleatorio (0-4)
        const nivelY = 50 + nivel * (estanteHeight / 5);

        // Producto (representado como un círculo)
        const productoX =
          50 +
          index * (estanteWidth + 20) +
          Math.random() * (estanteWidth - 20); // Aleatorio dentro del estante

        estante
          .circle(20)
          .fill("#ff5733")
          .move(productoX, nivelY + 10); // Un producto pequeño (círculo)
      }
    });
  }
}
